import {COMMON_BUILDING_TOKENS, SPECIAL_BUILDING_TOKENS} from "../../../constants/tokens";
import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";
import {ELEMENTALS_CONSTRUCTION_ELEMENTS} from "../../../configs/factions/elementals";

export const getElementForTokenType = (tokenType) => {
  const earthBuildings = new Set([...Object.values(SPECIAL_BUILDING_TOKENS), COMMON_BUILDING_TOKENS.QUARTER]);

  if (earthBuildings.has(tokenType) || checkIfCentralQuarter(tokenType)) {
    return ELEMENTALS_CONSTRUCTION_ELEMENTS.EARTH;
  }

  if (tokenType === COMMON_BUILDING_TOKENS.BARRACKS) {
    return ELEMENTALS_CONSTRUCTION_ELEMENTS.FIRE;
  }

  if (tokenType === COMMON_BUILDING_TOKENS.FARM) {
    return ELEMENTALS_CONSTRUCTION_ELEMENTS.WHEAT;
  }

  return null;
}